import type { FaireProductEntity } from "../../entity_types/product";

export const p_shjzef8gkq: FaireProductEntity = {
  token: "p_shjzef8gkq",
  type: "product",
  name: "W2168 | Knit Sweater Polyester Gingham Pattern Scarf",
  brandToken: "b_395xq4ekla",
  brandName: "By Together",
  imageUrl:
    "https://cdn.faire.com/fastly/ee829986587406a075f1283cf6a9f2e460904e5dba76eba151d6da8dc4c47923.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8281870c84290cf9d6e0459f826bb49d45e222848e4e4f2108cac977a22ed31e.jpeg",
    "https://cdn.faire.com/fastly/2c3045cd4142a4c24f97e1b67e981504b2b59b7c54c14b3c28d01167737b50b4.jpeg",
    "https://cdn.faire.com/fastly/3e0e1d463ce485a8cad46441019d7bab856cc1dbd41dd01a8d137f29a555c79b.jpeg",
  ],
  priceDollars: 14.95,
  description: "Knit Sweater Polyester Gingham Pattern Fringe Detail Scarf",
  tags: [],
  msrpDollars: 29.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:49.683Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
